import React, { Component } from "react";

class HotKeys extends Component {
  state = {
    functionMaps: {}
  };

  constructor(props) {
    super(props);
    Object.keys(props.keyMap).forEach(e => {
      const funKey = e;
      const key = props.keyMap[e];
      this.state.functionMaps[key] = props.handlers[funKey];
    });
  }
  componentDidMount() {
    document.addEventListener("keydown", this.keyDown);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.keyDown);
  }
  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      Object.keys(this.props.keyMap).forEach(e => {
        const funKey = e;
        const key = this.props.keyMap[e];
        this.setState(({ functionMaps }) => {
          functionMaps[key] = this.props.handlers[funKey];
          return { functionMaps };
        });
      });
    }
  }
  keyDown = ev => {
    // do not process keystrokes if viewer is not visible
    if (!this.wrapper.offsetParent) return;
    const key = this.createString(ev).toLowerCase();

    this.state.functionMaps[key] &&
      this.state.functionMaps[key](ev, document.activeElement);
  };

  createString = ev =>
    (ev.altKey ? "alt+" : "") +
    (ev.ctrlKey ? "ctrl+" : "") +
    (ev.metaKey ? "meta+" : "") +
    (ev.shiftKey ? "shift+" : "") +
    ev.key;

  render() {
    return (
      <div ref={ref => this.wrapper = ref} className="wrapper">
        {this.props.children}
      </div>
    );
  }
}

export default HotKeys;



// WEBPACK FOOTER //
// ./src/components/HotKeys.js